import {
    ProjectSettingsAction,
    ProjectSettingsType,
} from '../../actionTypes/settings/projectSettings';
import {
    IProjectTypeSettings,
    ProjectSettingsWithRestrictions,
} from '../../types';

const reducer = (
    state: {
        projectSettings: Array<IProjectTypeSettings>;
        restrictedIntakeIds: string[];
    } = {
        projectSettings: [],
        restrictedIntakeIds: [],
    },
    action: ProjectSettingsAction
): ProjectSettingsWithRestrictions => {
    switch (action.type) {
        case ProjectSettingsType.CREATE_PROJECT_SETTINGS: {
            const newCreatedState = { ...state };
            newCreatedState.projectSettings.push(action.payload);
            return newCreatedState;
        }
        case ProjectSettingsType.UPDATE_PROJECT_SETTINGS:
            return updateProjectTypeSettings(state, action.payload);
        case ProjectSettingsType.DELETE_PROJECT_SETTINGS: {
            const filteredProjectSettings = state.projectSettings.filter(
                (projectSetting) => projectSetting._id !== action.payload._id
            );
            return {
                projectSettings: filteredProjectSettings,
                restrictedIntakeIds: state.restrictedIntakeIds,
            };
        }
        case ProjectSettingsType.GET_PROJECT_SETTINGS:
            return action.payload;
        default:
            return state;
    }
};

const updateProjectTypeSettings = (
    state: ProjectSettingsWithRestrictions,
    updatedProjectType: IProjectTypeSettings
) => {
    const indexOfUpdated = state.projectSettings.findIndex(
        (item) => item._id === updatedProjectType._id
    );
    state.projectSettings[indexOfUpdated] = updatedProjectType;
    return { ...state };
};

export default reducer;
